import * as React from 'react';

import { BX_SAVED_SEARCH_FAVORITES_MERGE_EXPERIMENT } from '../../../../../constants/experiments';
import { ICommercialOwnershipSchema } from '../../../../../repositories/favorites/entities/commercial_ownership/CommercialOwnershipSchema';
import { ICommercialInfoSchema } from '../../../../../repositories/favorites/entities/favorite_entity_for_desktop/CommercialInfoSchema';
import { IOfferLabelSchema } from '../../../../../repositories/favorites/entities/favorite_entity_for_desktop/OfferLabelSchema';
import { IGeo } from '../../../../../types/geo';
import { IAgentSchema, IBargainTerms, IJKInfo } from '../../../../../types/results';
import { getIsOfferWithMultiAds } from '../../../../../utils/getIsOfferWithMultiAds';
import { AboutBuilding } from '../../../../AboutBuilding';
import { AboutBuildingMultiAds } from '../../../../AboutBuildingMultiAds';
import { Address } from '../../../../Address';
import { CardShields } from '../../../../CardShields';
import { Favorites } from '../../../../Favorites';
import { Labels } from '../../../../Labels';
import { OfferDescription } from '../../../../OfferDescription/OfferDescription';
import { OfferHeader } from '../../../../OfferHeader';
import { OfferHeaderMultiAds } from '../../../../OfferHeaderMultiAds';
import { Undergrounds } from '../../../../Undergrounds';
import { experimentToggle } from '../../../../experimentToggle';
import * as styles from '../../../Card.css';
import { CommercialInfoReadyBusiness } from '../CommercialInfoReadyBusiness';

interface ICardContentProps {
  agentInfo?: IAgentSchema | null;
  bargainTerms: IBargainTerms;
  commercialInfo?: ICommercialInfoSchema | null;
  description?: string | null;
  geo: IGeo;
  jkInfo?: IJKInfo | null;
  title: string;
  labels: IOfferLabelSchema[];
  titleForMobileSite?: string | null;
  commercialOwnership?: ICommercialOwnershipSchema | null;
  handleRemoveFavorites(): void;
  trackTitleClick(): void;
  isRedesignExperimentActive: boolean;
  isBooked: boolean;
  isEarlyAccessEnabled?: boolean;
}

export const CardContent: React.FC<ICardContentProps> = props => {
  const {
    agentInfo,
    bargainTerms,
    commercialInfo,
    description,
    geo,
    jkInfo,
    title,
    labels,
    titleForMobileSite,
    commercialOwnership,
    isRedesignExperimentActive,
    handleRemoveFavorites,
    trackTitleClick,
    isBooked,
    isEarlyAccessEnabled,
  } = props;

  const isMultiAds = getIsOfferWithMultiAds(commercialInfo);

  /**
   * Временное решение вынести блок с ценой в отдельную переменную, чтобы упростить код внутри experimentToggle
   */
  const Header =
    isMultiAds && bargainTerms.priceText ? (
      <OfferHeaderMultiAds>{bargainTerms.priceText}</OfferHeaderMultiAds>
    ) : (
      bargainTerms.priceText && (
        <OfferHeader
          price={bargainTerms.priceText}
          discount={bargainTerms.discount}
          isRedesignExperimentActive={isRedesignExperimentActive}
          isBooked={isBooked}
        />
      )
    );

  return (
    <>
      {
        /**
         * @todo experimentToggle - временное решение, удалить после завершения эксперимента aud_mobile_bx585_saved_search_favorites_merge
         */
        experimentToggle(
          isRedesignExperimentActive,
          BX_SAVED_SEARCH_FAVORITES_MERGE_EXPERIMENT,
          labels && <Labels labels={labels} />,
          labels && labels.length !== 0 && (
            <Labels labels={labels} isRedesignExperimentActive={isRedesignExperimentActive} />
          ),
        )
      }
      {commercialInfo?.readyBusinessType != null ? (
        <div
          data-testid="commercial-info-ready-business-wrapper"
          className={styles['commercial-info-ready-business-wrapper']}
        >
          <CommercialInfoReadyBusiness commercialInfo={commercialInfo} title={title} />
        </div>
      ) : (
        <>
          {
            /**
             * @todo experimentToggle - временное решение, удалить после завершения эксперимента aud_mobile_bx585_saved_search_favorites_merge
             */
            experimentToggle(
              isRedesignExperimentActive,
              BX_SAVED_SEARCH_FAVORITES_MERGE_EXPERIMENT,
              Header,
              <span className={styles['header--redesign']}>
                {Header}
                <div className={styles['favorite--redesign']}>
                  <Favorites onClick={handleRemoveFavorites} />
                </div>
              </span>,
            )
          }
          <div data-testid="card-shields" className={styles['shields_wrapper']}>
            <CardShields
              agentLists={agentInfo?.agentLists}
              isCommericalOwner={!!commercialOwnership?.isFromOwner}
              isEarlyAccessEnabled={isEarlyAccessEnabled}
              isMobile
            />
          </div>
          {isMultiAds ? (
            <AboutBuildingMultiAds isBooked={isBooked}>{titleForMobileSite}</AboutBuildingMultiAds>
          ) : (
            <AboutBuilding
              name={title}
              buildingInfo={jkInfo?.deadlineText ?? ''}
              onLinkClick={trackTitleClick}
              isBooked={isBooked}
            />
          )}
        </>
      )}
      {geo.undergrounds.length
        ? /**
           * @todo experimentToggle - временное решение, удалить после завершения эксперимента aud_mobile_bx585_saved_search_favorites_merge
           */
          experimentToggle(
            isRedesignExperimentActive,
            BX_SAVED_SEARCH_FAVORITES_MERGE_EXPERIMENT,
            <Undergrounds undergrounds={geo.undergrounds} />,
            <div className={styles['space']}>
              <Undergrounds undergrounds={[geo.undergrounds[0]]} />
            </div>,
          )
        : null}
      <Address address={geo.address} isRedesignExperimentActive={isRedesignExperimentActive} isBooked={isBooked} />
      {description ? <OfferDescription description={description} /> : null}
    </>
  );
};
